module.exports = __webpack_public_path__ + "static/img/selection_5.45e1d1ac.png";